/*
 * Prefetch on Hover
 * Prefetches internal pages when the user hovers over links,
 * similar to Shopify Hydrogen's link prefetching behavior.
 */
(function () {
  'use strict';

  // Bail out if data saver is enabled
  if (navigator.connection && navigator.connection.saveData) {
    return;
  }

  var prefetchedUrls = new Set();
  var hoverTimer = null;

  var idle =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : function (cb) {
          setTimeout(cb, 1);
        };

  function isInternalLink(anchor) {
    var href = anchor.getAttribute('href');
    if (!href) return false;
    if (href.startsWith('#') || href.startsWith('javascript:')) return false;
    // mailto / tel
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return false;

    try {
      var url = new URL(href, window.location.origin);
      return url.origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function getFullUrl(anchor) {
    try {
      var url = new URL(anchor.getAttribute('href'), window.location.origin);
      // Strip hash to avoid duplicate prefetches for same page with different anchors
      url.hash = '';
      return url.href;
    } catch (e) {
      return null;
    }
  }

  function prefetch(url) {
    if (prefetchedUrls.has(url)) return;
    prefetchedUrls.add(url);

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function findAnchor(target) {
    // Walk up the DOM to find the closest anchor element
    while (target && target !== document) {
      if (target.tagName === 'A' && target.hasAttribute('href')) {
        return target;
      }
      target = target.parentElement;
    }
    return null;
  }

  function onPointerIn(event) {
    var anchor = findAnchor(event.target);
    if (!anchor || !isInternalLink(anchor)) return;

    var url = getFullUrl(anchor);
    if (!url || prefetchedUrls.has(url)) return;

    // Small delay to avoid prefetching on accidental hovers
    hoverTimer = setTimeout(function () {
      idle(function () {
        prefetch(url);
      });
    }, 100);
  }

  function onPointerOut(event) {
    var anchor = findAnchor(event.target);
    if (!anchor) return;

    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  }

  // Attach listeners using event delegation on the document
  document.addEventListener('mouseenter', onPointerIn, true);
  document.addEventListener('mouseleave', onPointerOut, true);
  document.addEventListener('touchstart', onPointerIn, { capture: true, passive: true });
  document.addEventListener('touchend', onPointerOut, true);
  document.addEventListener('touchcancel', onPointerOut, true);
})();
